"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemIdMappings = exports.getItemDetails = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getItemDetails = function getItemDetails(itemId, accessToken) {
  return _axios["default"].get("https://item-service.commerce.cimpress.io/v1/items/".concat(itemId), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data;
  });
};
exports.getItemDetails = getItemDetails;
var getItemIdMappings = function getItemIdMappings(itemId, accessToken) {
  return _axios["default"].get("https://item-service.commerce.cimpress.io/v1/itemmappings?orderItemId=".concat(itemId), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data;
  });
};
exports.getItemIdMappings = getItemIdMappings;